(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    const track = root.querySelector('[data-carousel-track]');
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const pause = root.querySelector('[data-carousel-pause]');
    if (!track || slides.length < 2) return;
    let index = 0;
    let timer;
    let hovered = false;
    let inView = true;
    let pausePointerState = null;
    let paused = reduced.matches || root.dataset.autoplay !== 'true';
    const interval = Math.max(5000, Number(root.dataset.interval) || 7000);
    function update() {
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (pause) {
        pause.textContent = paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
        pause.setAttribute('aria-pressed', String(paused));
      }
    }
    function restart() {
      clearInterval(timer);
      if (!paused && !hovered && inView && !document.hidden && root.isConnected) timer = setInterval(() => go(index + 1), interval);
    }
    function go(next, manual = false) {
      index = (next + slides.length) % slides.length;
      if (manual) paused = true;
      track.scrollTo({ left: index * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
      update(); restart();
    }
    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => go(index - 1, true));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => go(index + 1, true));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i, true)));
    pause?.addEventListener('pointerdown', () => { pausePointerState = paused; });
    pause?.addEventListener('click', () => { paused = pausePointerState === null ? !paused : !pausePointerState; pausePointerState = null; update(); restart(); });
    root.addEventListener('mouseenter', () => { hovered = true; restart(); });
    root.addEventListener('mouseleave', () => { hovered = false; restart(); });
    root.addEventListener('focusin', () => { paused = true; update(); restart(); });
    track.addEventListener('pointerdown', () => { paused = true; update(); restart(); }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1), true);
      }
    });
    track.addEventListener('scroll', () => {
      const next = Math.round(track.scrollLeft / track.clientWidth);
      if (next !== index && next >= 0 && next < slides.length) { index = next; update(); }
    }, { passive: true });
    const resize = new ResizeObserver(() => track.scrollTo({ left: index * track.clientWidth, behavior: 'instant' }));
    resize.observe(track);
    const visible = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting; restart();
    });
    visible.observe(root);
    const visibility = () => restart();
    document.addEventListener('visibilitychange', visibility);
    const motion = () => { if (reduced.matches) paused = true; update(); restart(); };
    reduced.addEventListener('change', motion);
    root.addEventListener('bright:destroy', () => {
      clearInterval(timer); resize.disconnect(); visible.disconnect();
      document.removeEventListener('visibilitychange', visibility);
      reduced.removeEventListener('change', motion);
    }, { once: true });
    root.addEventListener('bright:select', event => {
      const i = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (i >= 0) go(i, true);
    });
    update(); restart();
  }
  document.querySelectorAll('[data-bright-carousel]').forEach(initCarousel);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bright-carousel]').forEach(initCarousel));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bright-carousel]').forEach(root => root.dispatchEvent(new Event('bright:destroy'))));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-bright-carousel]');
    if (root) root.dispatchEvent(new CustomEvent('bright:select', { detail: { blockId: event.detail.blockId } }));
  });
})();
